import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.19, 1, 0.22, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, play = true }) => (
  <span className="text-mask">
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: play ? "0%" : "110%" }}
      transition={{ duration: 1, delay: play ? delay : 0, ease: [0.19, 1, 0.22, 1] }}
    >
      {children}
    </motion.span>
  </span>
);
